<div class="container">
  <ul class="fantasy-nav" #navContainer>
    <div class="line-indicator" #indicator></div>
    <a
      class="nav-item leaderboard-nav-item"
      [routerLink]="['/games/pickaplayer/play']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'game.nav. fantasy.v2.screenreader' | translate }}"
    >
      <label>{{ 'fantasy.v2.nav.featured' | translate: { fgbdefault: 'Play' } }}</label>
    </a>

    <a
      class="nav-item leaderboard-nav-item"
      [routerLink]="['/games/pickaplayer/up-next']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'game.nav.fantasy.v2.up.next.screenreader' | translate }}"
    >
      <label>{{ 'fantasy.v2.nav.up.next' | translate: { fgbdefault: 'Up Next' } }}</label>
    </a>

    <a
      class="nav-item leaderboard-nav-item"
      [routerLink]="['/games/pickaplayer/leaderboard']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'game.nav.fantasy.v2.leaderboard.screenreader' | translate }}"
    >
      <label>{{ 'games.nav.fantasy.v2.leaderboard' | translate: { fgbdefault: 'Leaderboard' } }}</label>
    </a>

    <a
      class="nav-item leaderboard-nav-item"
      [routerLink]="['/games/pickaplayer/results']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'game.nav.fantasy.v2.results.screenreader' | translate }}"
    >
      <label>{{ 'fantasy.v2.nav.results' | translate: { fgbdefault: 'Results' } }}</label>
    </a>

    <a
      class="nav-item leaderboard-nav-item"
      [routerLink]="['/games/pickaplayer/rules']"
      [routerLinkActive]="'active'"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'game.nav.fantasy.v2.rules.screenreader' | translate }}"
    >
      <label>{{ 'fantasy.v2.nav.rules' | translate: { fgbdefault: 'Rules' } }}</label>
    </a>
  </ul>
</div>
